import { ACT_ROL_CHANGE } from "../actions/ActionTypes";

const initialState = {
	rolList:[]
};

export default function(state = initialState, action) {
	if (action.type === ACT_ROL_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/RolReducer.js